import { useEffect, useState } from "react";
import { PAINTS, type Paint } from "./CarGraphic";
import { PLATE } from "../types";

const KEY = "carauto.paint";
// The real car is Magma Grey.
const DEFAULT_PAINT = PAINTS.find((p) => p.name === "Magma Grey") ?? PAINTS[0];

function loadPaint(): Paint {
  try {
    const n = localStorage.getItem(KEY);
    return PAINTS.find((p) => p.name === n) ?? DEFAULT_PAINT;
  } catch { return DEFAULT_PAINT; }
}

// Paint choice, persisted per phone.
export function usePaint(): [Paint, (p: Paint) => void] {
  const [paint, setPaint] = useState<Paint>(loadPaint);
  useEffect(() => { try { localStorage.setItem(KEY, paint.name); } catch { /* private mode */ } }, [paint]);
  return [paint, setPaint];
}

// Nameplate for the 2018 Maruti Suzuki Dzire VXi — sits in the header.
export function Nameplate() {
  return (
    <div className="nameplate">
      <p className="sc-make">Maruti Suzuki</p>
      <h1 className="sc-model">DZIRE <span className="sc-variant">VXi</span> <span className="sc-yr">2018</span> <span className="sc-reg">{PLATE}</span></h1>
    </div>
  );
}
